import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RUReservationsService } from '../ru-reservations.service';
import { RUReservations } from '../ru-reservations';
import { RUReservationsComponent } from '../ru-reservations/ru-reservations.component';

@Component({
    selector: 'app-ru-reservations-list',
    templateUrl: './ru-reservations-list.component.html',
    styleUrls: ['./ru-reservations-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class RUReservationsListComponent implements OnInit {
	constructor(
		private ruReservationService: RUReservationsService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = ruReservationService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	ruReservations: any;
	ruReservation: RUReservations;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'ruReservationId', header: 'Id', width: 'auto' },
		{ field: 'reservationId', header: 'Res #', width: 'auto' },
		{ field: 'propertyId', header: 'propertyId', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'email', header: 'Email', width: 'auto' },
		{ field: 'dateFrom', header: 'From', width: 'auto' },
		{ field: 'dateTo', header: 'To', width: 'auto' },
		{ field: 'arrivalTime', header: 'Arrival Time', width: 'auto' },
		{ field: 'numberOfGuests', header: 'numberOfGuests', width: 'auto' },
		
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.ruReservationId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ruReservation-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ruReservationService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ruReservations = res.data.ruReservations;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ruReservations = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(ruReservation: RUReservations) {
		try {
			this.formLoading = true;
			this.ruReservationService.update(ruReservation)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ruReservations.map((ruReservation, i) => {
							if (ruReservation.ruReservationId === res.data.ruReservation.ruReservationId) {
								this.ruReservations[i] = res.data.ruReservation;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(ruReservation: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(ruReservation));

			this.formLoading = true;
			this.ruReservationService.delete(ruReservation.ruReservationId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ruReservations.splice(this.ruReservations.indexOf(ruReservation), 1);
						this.recordTotal = this.ruReservations.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'RUReservation ' + ruReservation.ruReservationId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'RUReservation ' + ruReservation.ruReservationId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add RUReservation'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RUReservationsComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addRUReservationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(ruReservation: RUReservations) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ruReservation: ruReservation,
			title: 'Edit RUReservation'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RUReservationsComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateRUReservationCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteRUReservationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addRUReservationCB(ruReservation: RUReservations) {
		console.log('Adding RUReservation: ' + JSON.stringify(ruReservation));
		// if we don't have a ruReservations array yet...
		if (!this.ruReservations) {
			this.ruReservations = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ruReservations.unshift(ruReservation);

		// no idea what this is but it is required to update the array
		this.ruReservations = [...this.ruReservations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RUReservation ' + ruReservation.ruReservationId + ' Added', life: 3000 });
	}

	updateRUReservationCB(ruReservation: RUReservations) {
		console.log('Updating RUReservation: ' + JSON.stringify(ruReservation));
		let itemIndex = this.ruReservations.findIndex((item: any) => item.ruReservationId === ruReservation.ruReservationId);
		this.ruReservations[itemIndex] = ruReservation;

		// no idea what this is but it is required to update the array
		this.ruReservations = [...this.ruReservations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RUReservation ' + ruReservation.ruReservationId + ' Updated', life: 3000 });
	}

	deleteRUReservationCB(ruReservation: RUReservations) {
		console.log('Removing RUReservation: ' + ruReservation);
		this.ruReservations.splice(this.ruReservations.indexOf(ruReservation), 1);
		this.recordTotal = this.ruReservations.length;

		// no idea what this is but it is required to update the array
		this.ruReservations = [...this.ruReservations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RUReservation ' + ruReservation.ruReservationId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.ruReservations ? this.first === (this.ruReservations.length - this.rows) : true; }
	isFirstPage(): boolean { return this.ruReservations ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(ruReservation: any) {
		if (ruReservation?.status) {
			const status = this.statuses.find((e: any) => e.value == ruReservation.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
